import React from 'react'
import PropTypes from 'prop-types'
import {Box, Skeleton} from '@chakra-ui/react'
import BillCard from './BillCard'

const MediumBillsTable = ({bills, isLoading, onSelectPayee}) => {
  if (isLoading) {
    return (
      <Box>
        {[1, 2, 3].map((i) => (
          <Skeleton key={i} height="140px" mb="sm" borderRadius="md" />
        ))}
      </Box>
    )
  }

  return (
    <Box className="fs-unmask">
      {bills.map((bill) => (
        <BillCard key={bill.id} bill={bill} onSelectPayee={onSelectPayee} />
      ))}
      <Box borderTop="1px solid" borderColor="mld.neutral.200" />
    </Box>
  )
}

MediumBillsTable.propTypes = {
  bills: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  isLoading: PropTypes.bool.isRequired,
  onSelectPayee: PropTypes.func.isRequired,
}

export default MediumBillsTable
